import { State } from '~/screens/ScenariosScreen/types';

export const feedbackWidgetsURL = '/feedback-widgets';

export const emptyState: State = {
  selectedGroup: 0,
  selectedPreset: null,
  selectedScenario: null,
  isScenarioLoading: false,
  isHowVisible: false,
  isTemplatesVisible: false,
  isErrorMessageVisible: false,
  isErrorWhenCheckScriptException: false,
};
